export default function elementSize(el) {
  if (el && el instanceof HTMLElement) {
    const height = el.offsetHeight || 0;
    const width = el.offsetWidth || 0;

    const style = window.getComputedStyle(el) || {};
    const paddingLeft = parseInt(style.paddingLeft, 10) || 0;
    const paddingRight = parseInt(style.paddingRight, 10) || 0;
    const paddingTop = parseInt(style.paddingTop, 10) || 0;
    const paddingBottom = parseInt(style.paddingBottom, 10) || 0;
    const lineHeight = parseInt(style.lineHeight, 10) || 0;

    const newHeight = height - paddingTop - paddingBottom;
    const newWidth = width - paddingLeft - paddingRight;

    return { height: newHeight, width: newWidth, lineHeight };
  }
}
